import React from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../redux/store';
import { clearCrewManagerPopupPending } from '../redux/auth/authSlice';
import { useGetDashboardQuery } from '../api/userApi';
import useRedux from '../hooks/useRedux';

const CrewManagerPopupModal = () => {
    const { dispatch } = useRedux();
    const { t } = useTranslation();
    const authenticated = useSelector((state: RootState) => state.auth.authenticated);
    const currentProjectId = useSelector((state: RootState) => state.auth.currentProjectId);
    const pending = useSelector((state: RootState) => state.auth.crewManagerPopupPending);
    // the api rejects every request until privacy statements are accepted
    const loginIncomplete = useSelector((state: RootState) => !!state.auth.hasUnacceptedPrivacyStatements);
    const { data: dashboardData } = useGetDashboardQuery(undefined, {
        skip: !authenticated || !pending || loginIncomplete,
    });

    const project = dashboardData?.projectCrews?.find((p: any) => p.id === currentProjectId);
    const isManager = !!project?.crews?.some((c: any) => c.isManager);
    const popupText = project?.crewManagerPopupText;
    const show = !!pending && !!currentProjectId && isManager && !!popupText;

    const close = () => dispatch(clearCrewManagerPopupPending());

    return (
        <Modal show={show} onHide={close} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('crewManagerPopup.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body dangerouslySetInnerHTML={{ __html: popupText || '' }} />
        </Modal>
    );
};

export default CrewManagerPopupModal;
